import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Programs } from './pages/Programs';
import { About } from './pages/About';
import { Events } from './pages/Events';
import { Shop } from './pages/Shop';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { Donate } from './pages/Donate';
import { Volunteer } from './pages/Volunteer';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { FAQ } from './pages/FAQ';
import { Sitemap } from './pages/Sitemap';
import { Cart } from './pages/Cart';
import { ProductDetails } from './pages/ProductDetails';
import { Checkout } from './pages/Checkout';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { CartProvider } from './context/CartContext';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
const PageTransition = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    pathname
  } = useLocation();
  return <motion.div key={pathname} initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} data-id="element-0" data-mp="5yk6vxnnffx">
      {children}
    </motion.div>;
};
export function App() {
  return <CartProvider data-id="element-1" data-mp="33orjc3pos1qk">
      <BrowserRouter data-id="element-2" data-mp="38lrpeemjd4ho">
        <ScrollToTop data-id="element-3" data-mp="38li9jjv7gdpp" />
        <div className="min-h-screen bg-warmwhite font-sans text-charcoal selection:bg-gold/20 selection:text-gold flex flex-col" data-id="element-4" data-mp="38l05w267qx7r">
          <Navbar data-id="element-5" data-mp="3dirvgpjdy78s" />
          <main className="flex-grow" data-id="element-6" data-mp="nvj179a902mk">
            <AnimatePresence mode="wait" data-id="element-7" data-mp="nuhjilyq8hvv">
              <Routes data-id="element-8" data-mp="nxww9i4xheu4">
                <Route path="/" element={<PageTransition data-id="element-10" data-mp="stkn01z26g1q"><Home data-id="element-11" data-mp="stccggqermtp" /></PageTransition>} data-id="element-9" data-mp="sudnwmbc6bby" />
                <Route path="/programs" element={<PageTransition data-id="element-13" data-mp="35ovimiemwr0"><Programs data-id="element-14" data-mp="356rv4texg92" /></PageTransition>} data-id="element-12" data-mp="36huv2f1ajz4" />
                <Route path="/about" element={<PageTransition data-id="element-16" data-mp="3udkmfuysas9v"><About data-id="element-17" data-mp="3ubzt28o7hfdl" /></PageTransition>} data-id="element-15" data-mp="3uct25gan0gyw" />
                <Route path="/events" element={<PageTransition data-id="element-19" data-mp="d57dixer88gf"><Events data-id="element-20" data-mp="d3mn9jzh3bod" /></PageTransition>} data-id="element-18" data-mp="3uf5g7id9y76o" />
                <Route path="/shop" element={<PageTransition data-id="element-22" data-mp="851kpdwr0fwr"><Shop data-id="element-23" data-mp="85bc95xfyv4k" /></PageTransition>} data-id="element-21" data-mp="d2bj3j2481wq" />
                <Route path="/product/:id" element={<PageTransition data-id="element-25" data-mp="3gl4q1d0e1shx"><ProductDetails data-id="element-26" data-mp="3gklbm69y5m8n" /></PageTransition>} data-id="element-24" data-mp="83i2vivg1wsv" />
                <Route path="/cart" element={<PageTransition data-id="element-28" data-mp="3bmtixa1h9w3e"><Cart data-id="element-29" data-mp="3bn30c98giuxh" /></PageTransition>} data-id="element-27" data-mp="3gj1t090tiz3p" />
                <Route path="/checkout" element={<PageTransition data-id="element-31" data-mp="3qaxtfqqdn1b3"><Checkout data-id="element-32" data-mp="3qbfx38fdcht1" /></PageTransition>} data-id="element-30" data-mp="3bk70gfd1tw6e" />
                <Route path="/order-confirmation" element={<PageTransition data-id="element-34" data-mp="3ljxtsdpvi54w"><OrderConfirmation data-id="element-35" data-mp="3ljg2lvi2ih3u" /></PageTransition>} data-id="element-33" data-mp="3qdaisoygsdy6" />
                <Route path="/blog" element={<PageTransition data-id="element-37" data-mp="2xudec4sxhq0d"><Blog data-id="element-38" data-mp="2xtv7ke8n3te7" /></PageTransition>} data-id="element-36" data-mp="3limuor7dhlk4" />
                <Route path="/contact" element={<PageTransition data-id="element-40" data-mp="2swbs5b07hako"><Contact data-id="element-41" data-mp="2swlhcwdffdpb" /></PageTransition>} data-id="element-39" data-mp="2xsk2mb3gkfli" />
                <Route path="/donate" element={<PageTransition data-id="element-43" data-mp="18e17fdz2bcgv"><Donate data-id="element-44" data-mp="18dhpvydbqq3d" /></PageTransition>} data-id="element-42" data-mp="2stplrep1x141" />
                <Route path="/volunteer" element={<PageTransition data-id="element-46" data-mp="1d47ydkh1r92a"><Volunteer data-id="element-47" data-mp="1d4recvn4zndo" /></PageTransition>} data-id="element-45" data-mp="18boi2fqz5zts" />
                <Route path="/terms" element={<PageTransition data-id="element-49" data-mp="yfv8n58jymg8"><Terms data-id="element-50" data-mp="yg3kquwupnqd" /></PageTransition>} data-id="element-48" data-mp="1d6kmkfdeefns" />
                <Route path="/privacy" element={<PageTransition data-id="element-52" data-mp="13eofietc3f7f"><Privacy data-id="element-53" data-mp="13e57bpthk56l" /></PageTransition>} data-id="element-51" data-mp="yheq2z5y33jl" />
                <Route path="/faq" element={<PageTransition data-id="element-55" data-mp="1r499dsr0zwvh"><FAQ data-id="element-56" data-mp="1r4iq0pq6kroi" /></PageTransition>} data-id="element-54" data-mp="13ey541agvkcl" />
                <Route path="/sitemap" element={<PageTransition data-id="element-58" data-mp="1r2g1yb8l98mf"><Sitemap data-id="element-59" data-mp="1w33pgmxlz7bw" /></PageTransition>} data-id="element-57" data-mp="1r4sgeef510uq" />
              </Routes>
            </AnimatePresence>
          </main>
          <Footer data-id="element-60" data-mp="1i441lhhx6wgs" />
        </div>
      </BrowserRouter>
    </CartProvider>;
}